import { RefreshCw, WifiOff } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useIsOnline } from "@/lib/api/online-manager";

/**
 * Écran affiché quand l'application démarre sans réseau ET sans session
 * restaurable. Il remplace la redirection vers `/login` : envoyer quelqu'un
 * vers un formulaire de connexion qui exige justement le réseau donnait le
 * message le plus trompeur possible — « vous avez été déconnecté » alors que
 * rien n'est perdu côté serveur.
 */
export function OfflineScreen({ onRetry }: { onRetry: () => void }) {
  const online = useIsOnline();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md rounded-lg border border-border bg-card p-8 text-center">
        <WifiOff className="mx-auto h-10 w-10 text-warning" aria-hidden />
        <h1 className="mt-4 text-lg font-semibold text-foreground">Aucune connexion</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          L&apos;application n&apos;a pas pu joindre le serveur. Votre session n&apos;est pas
          perdue : reconnectez le réseau puis réessayez.
        </p>
        <Button className="mt-6 w-full" onClick={onRetry}>
          <RefreshCw className="mr-2 h-4 w-4" aria-hidden />
          Réessayer
        </Button>
        <p className="mt-3 text-xs text-muted-foreground" role="status" aria-live="polite">
          {online
            ? "Le réseau est revenu — réessayez."
            : "En attente du réseau…"}
        </p>
      </div>
    </div>
  );
}
